import { styled } from '@mui/material/styles';
import { excludeProps } from '@shared/theme/util';
import { BodyCell } from '../../components/BodyCell';

interface TableHeadCellProps {
  sortable?: boolean;
  columnGroup?: boolean;
}

export const HeadCell = styled(BodyCell, {
  name: 'Table',
  slot: 'HeadCell',
  shouldForwardProp: (propName: string) =>
    excludeProps(propName, ['sortable', 'columnGroup']),
})<TableHeadCellProps>(({ theme, sortable = false, columnGroup = false }) => ({
  verticalAlign: 'bottom',
  lineHeight: 2.75,
  backgroundColor: theme.palette.background.paper,
  ...(sortable && {
    cursor: 'pointer',
  }),
  ...(columnGroup && {
    lineHeight: 1.5,
    height: 'unset',
  }),
}));
